import { slideDown, slideUp } from '../../utils/slide-functions';

(function () {
  const staffListings = document.querySelectorAll('.staff-listing');
  staffListings.forEach((staffListing, index) => {
    const listingItems = staffListing.querySelectorAll('.staff-item');
    const listingTitle = staffListing.previousElementSibling as HTMLElement;

    if (listingTitle && listingTitle.classList.contains('content-block')) {
      staffListing.setAttribute('aria-label', listingTitle.textContent?.replace(/\s{2,10}/g, ' ').trim() + ' Staff');
    } else {
      if (index == 0) {
        staffListing.setAttribute('aria-label', 'Staff Listing');
      } else {
        staffListing.setAttribute('aria-label', 'Staff Listing ' + index);
      }
    }

    listingItems.forEach((listingItem) => {
      const item = listingItem as HTMLElement;
      const bio = item.dataset.bio;
      const email = item.dataset.email;
      const phone = item.dataset.phone;
      const parent = item.parentElement;
      const infoTrigger = item.querySelector('.info-trigger') as HTMLButtonElement;


      if (infoTrigger) {
        infoTrigger.addEventListener('click', (event) => {
          event.preventDefault();

          const infoContainer = document.createElement('div');

          infoContainer.className = 'info-container col-xs-12';
          infoContainer.setAttribute('tabindex', '-1');
          infoContainer.innerHTML = `
              <div class="inner">
                  <div class="content"></div>
                  <div class="contact"></div>
                  <button class="close" type="button">Close</button>
              </div>
          `;
          const content = infoContainer.querySelector('.content') as HTMLElement;
          const contact = infoContainer.querySelector('.contact') as HTMLElement;

          if (infoTrigger.classList.contains('active')) {
            infoTrigger.classList.remove('active');
            listingItem.classList.remove('active');
            slideUp(parent?.querySelector('.info-container') as HTMLElement);
          } else {
            setTimeout(() => {
              staffListing.querySelectorAll('.staff-item .info-trigger').forEach((trigger) => {
                trigger.classList.remove('active');
                trigger.parentElement?.classList.remove('active');
              });

              if (bio !== '') {
                content.insertAdjacentHTML('beforeend', `<p>${bio}</p>`);
              } else {
                content.insertAdjacentHTML(
                  'beforeend',
                  `<p>We're sorry we're still writing out this bio, check back again soon!</p>`,
                );
              }

              if (email !== '') {
                contact.insertAdjacentHTML(
                  'beforeend',
                  `<div class='detail-row email'><img src='/ResourcePackages/Talon/assets/dist/images/email.png' alt='Envelope icon' aria-hidden='true'/><span class='visuallyhidden'>Email</span> <a href='mailto:${email}'>${email}</a></div>`,
                );
              }

              if (phone !== '') {
                contact.insertAdjacentHTML(
                  'beforeend',
                  `<div class='detail-row phone'><img src='/ResourcePackages/Talon/assets/dist/images/phone.png' alt='Phone icon' aria-hidden='true'/><span class='visuallyhidden'>Phone</span> <a href='tel:${phone}' aria-hidden='true'>${phone}</a></div>`,
                );
              }

              if (matchMedia('(min-width:60em)').matches && parent) {
                parent.appendChild(infoContainer);
              } else {
                infoContainer.insertAdjacentElement('afterend', item);
              }

              if (parent) {
                const infoContainer = parent.querySelector('.info-container') as HTMLElement;
                const close = infoContainer.querySelector('.close') as HTMLButtonElement;
                slideDown(infoContainer);
                setTimeout(() => {
                  infoContainer.focus();
                  item.classList.add('active');

                  close.addEventListener('click', (event) => {
                    event.preventDefault();
                    infoTrigger.classList.remove('active');
                    item.classList.remove('active');
                    slideUp(infoContainer);

                    setTimeout(() => {
                      infoContainer.remove();
                      infoTrigger.focus();
                    }, 310);
                  });
                }, 310);
              }
            }, 450);
          }
        });
      }
    });
  });
})();
